<template>
<div id="production" class="flex-c">
    <!-- <van-image :src="productionImg" width="10rem" class="flex-self-ctr"></van-image>
    <van-image :src="logo" width="10rem" class="flex-self-ctr offset"></van-image> -->
    <div>
        <img class="banner" src="https://static.medsci.cn/public-image/ms-image/a4f96f20-675a-11eb-9312-b513295fbf74_1612492412(1).jpg" alt="">
    </div>
    <p>
        施维雅天津工厂致力于最大化的本地生产，为越来越多的患者提供优质治疗药物产品。
    </p>
    <p>
        从2002年9月开业至今，为了满足施维雅中国不断发展的业务需求，天津工厂在2008年（新仓库扩建）和2014年（新QC实验楼建成）先后两次扩建，2017年，公司再次增资建设，新厂房主体于2018年建设完成，并于2020年底通过天津食品药品监督管理局的现场药品生产质量管理规范（GMP）审查。
    </p>
    <p>
        新的生产单元将让工厂的生产能力实现翻番；开素达<sup>®</sup>（培哚普利氨氯地平片）的本地化分装工作正式开启，同时为今后生产更多创新药物提供了可能。
    </p>
    <p>
        除本地化生产以外，施维雅天津工厂还负责优化本地分销网络。2019年施维雅中国通过DMP项目实现分销平台的扁平化，进一步提升患者用药的可及性，革新天津工厂统一支持各地配送的模式，由天津工厂生产的货物根据计划转移到相应位于上海、广州、天津三地的物流平台，再分别支持全国配送；有效降低物流成本47%。
    </p>
    <p>
        施维雅天津工厂厂长张建敏表示:“让我们的生产和供应更贴近客户、更贴近患者，提供更优质的服务，为施维雅中国做大做强打下坚实的基石。”
    </p>
</div>
</template>

<script>
export default {
    data() {
        return {
            productionImg: require('@/assets/production.png'),
            logo: require('@/assets/logo.gif')
        }
    },
    created() {},
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#production{
    padding-bottom: 100px;
    .offset{
        transform: translateY(-100px);
        background-color: #ffffff;
        z-index: 9;
    }
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 30px;
    p {
        font-size: 26px;
        line-height: 70px;
        text-indent: 2em;
        margin-bottom: 20px;
    }
    .banner {
        width: 100%;
        vertical-align: middle;
        margin: 46px 0;
    }
}
</style>
